import { render, staticRenderFns } from "./SkeletonSingleCommodity.vue?vue&type=template&id=21e89538&scoped=true&"
import script from "./SkeletonSingleCommodity.vue?vue&type=script&lang=js&"
export * from "./SkeletonSingleCommodity.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonSingleCommodity.vue?vue&type=style&index=0&id=21e89538&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e89538",
  null
  
)

export default component.exports